<style>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
/* input[type=number] {
  -moz-appearance: textfield;
} */
</style>
    <a id="mbfs-header-login-cta" id="auto_trigger_registrationConfirm" class="mbfs-header-login-cta-a" href="javascript:void(0)" (click)="onClickLogin($event)" hidden></a>

  <!--Failure Scenario-->
      <form *ngIf="openLoginModal && invalidToken">
        <div class="mbfs-bank-profile-create-modal mbfs-modal" focustrapper aria-live="polite"
        [attr.aria-hidden]="openLoginModal" [class.open]="this.openLoginModal === true">
          <div class="mbfs-modal-overlay"></div>  
          <div class="mbfs-modal-content"> 
            <h3 class="mbfs-modal-header">{{ 'LoginModal.AccountRegistration' | translate }}</h3>
            <div class="mbfs-bank-profile-create-inner"> 
              <br><br><br><br><br><br>
                <p class="mbfs-passwordreset-p">{{ 'LoginModal.InvalidResetLink' | translate }}</p>
                <!-- <p class="mbfs-passwordreset-p">{{ 'LoginModal.OR' | translate }}</p>
                <div class ="registrationlinks">
                  <p class="mbfs-passwordreset-p" >{{ 'LoginModal.Registerhref' | translate }}</p>
                </div> -->
                <!-- <button type="submit" class="mbfs-button" (click)="reregister()" >{{ 'LoginModal.ReRegister' | translate }}</button> -->
              <button type="link" class="link mbfs-modal-close" (click)="closeCIAMModal($event)">X</button>
            </div>
          </div>
          </div>
      </form>



    <!--SelectBoxes eBill,Autopay-->
    <form [formGroup]="optionForm" (ngSubmit)="submiteBilloption($event)" *ngIf="openLoginModal && optionExist">
      <div class="mbfs-bank-profile-create-modal mbfs-modal" focustrapper aria-live="polite"
      [attr.aria-hidden]="openLoginModal" [class.open]="this.openLoginModal === true">
        <div class="mbfs-modal-overlay"></div>  
    
        <!--If user Exists and and password does not need to be reset -->
        <div class="mbfs-modal-content">  
          <button type="link" class="link mbfs-modal-close" (click)="closeCIAMModal($event)">X</button>

               <h3 class="mbfs-modal-header">{{'LoginModal.ManageEbill'| translate}}</h3>
            <div class="mbfs-bank-profile-create-inner">
     <div class ="registrationlinks">
                  <!-- <div class="mbfs-passwordreset-title" style="display:flex;">
                    <input  style="margin-top:3px;margin-bottom: 3px;margin-left:120px;margin-right:3px;width:17px;height:17px;" type="checkbox" name="test" [checked]="currentlyChecked === check_box_type.ENROLL_AUTOPAY" (click)="selectCheckBox(check_box_type.ENROLL_AUTOPAY)"> 
                     <h5 class="mbfs-footer-nav-links-header"  style="font-size:1.1rem ;"> Enroll me in Autopay</h5>
                    
                  </div> <br> -->
                  <!-- <div class="mbfs-passwordreset-title" style="display:flex;">
                    <input type="checkbox" style="margin-top:3px;margin-bottom: 3px;margin-left:120px;margin-right:3px;width:17px;height:17px;" name="test" [checked]="currentlyChecked === check_box_type.ENROLL_EBILL" (click)="selectCheckBox(check_box_type.ENROLL_EBILL)"> 
                    <h5 class="mbfs-footer-nav-links-header" style="font-size:1.1rem ;">{{'LoginModal.Enrollme'| translate}}</h5>
                </div>  -->
                <br>
                <div class="mbfs-passwordreset-title" style="display:flex;">
                    <input type="checkbox" style="margin-top:3px;margin-bottom: 3px;margin-left:120px;margin-right:3px;width:17px;height:17px;" name="test" [checked]="currentlyChecked === check_box_type.LATER" (click)="selectCheckBox(check_box_type.LATER)">  
                    <h5 class="mbfs-footer-nav-links-header"  style="font-size:1.1rem ;">{{'LoginModal.Later'| translate}} </h5>
                </div><br>
                </div> 
                   <br>
                <!--Error Display to Modal View-->
                <div class="mbfs-cavd-error-block mbfs-white-content-box" *ngIf="this.serviceErrorOccurred">
                  <h5 class="mbfs-modal-error">{{this.serviceErrorDesc}}<br></h5>
                </div>
              <button type="submit" [disabled]="!enableEbillContinue" class="mbfs-button">{{ 'LoginModal.Continue' | translate }}</button>
                <br>
            </div> 
         </div>
        </div>
    </form>
      
    <form  (ngSubmit)="openLogin($event)" *ngIf="openLoginModal && successExist">
      <div class="mbfs-bank-profile-create-modal mbfs-modal" focustrapper aria-live="polite"
      [attr.aria-hidden]="openLoginModal" [class.open]="this.openLoginModal === true">
        <div class="mbfs-modal-overlay"></div>   
    
        <!--If user Exists and and password does not need to be reset -->
         <div class="mbfs-modal-content"  *ngIf="successExist">  
          <button type="link" class="link mbfs-modal-close" (click)="closeCIAMModal($event)">X</button>

              <h3 class="mbfs-modal-header">{{ 'LoginModal.AccountRegistration' | translate }}</h3>
            <div class="mbfs-bank-profile-create-inner">
     <div class ="registrationlinks">
                <div class="mbfs-passwordreset-title" >
                  <b>{{ 'LoginModal.Success' | translate }}</b>
                </div> <br>
                  <!-- <div class="mbfs-passwordreset-title" >
                    <b>{{ 'LoginModal.Registered' | translate }}</b>
                  </div> <br><br> -->
                  <div class="mbfs-passwordreset-title" >
                    <b>{{ 'LoginModal.LoggedIn' | translate }}</b>
                  </div> <br>
                </div> 
                   <br>
              <button type="submit" class="mbfs-button">{{ 'LoginModal.LogIn' | translate }}</button>
                <br>
            </div>  
            
         </div>
    </div>
    </form> 
     